import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';

const StripeCheckoutPage = ({ stripeKey }: { stripeKey: string }) => {
  const stripePromise = loadStripe(stripeKey);

  const getClientSecretFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('client_secret');
  };

  const clientSecret =
    getClientSecretFromUrl() ||
    localStorage.getItem('client_secret_checkout_subscribe')

  const options = { clientSecret };

  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
};

export default StripeCheckoutPage;
